import { Component } from '@angular/core';
import { IAlert } from 'src/app/core/interfaces/alert';
import { AlertService } from 'src/app/core/services/alert.service';

@Component({
  standalone: false,
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.css']
})
export class alertComponent {

    info!:IAlert;
    visible:boolean = false;

    constructor(
        private alertService: AlertService
    ) { }

    ngOnInit() {
        this.alertService.init.subscribe((data) => {
            this.info = data.alert
            this.visible = data.visible
        }); 
    }

    cerrar(){
        this.alertService.close();
    }

}